import { render, staticRenderFns } from "./rests.vue?vue&type=template&id=13a1a94d&scoped=true"
import script from "./rests.vue?vue&type=script&lang=js"
export * from "./rests.vue?vue&type=script&lang=js"
import style0 from "./rests.vue?vue&type=style&index=0&id=13a1a94d&prod&lang=less"
import style1 from "./rests.vue?vue&type=style&index=1&id=13a1a94d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1a94d",
  null
  
)

export default component.exports